export default "__VITE_ASSET__CIyZzsSN__"